import { render } from "./SourceTag.vue?vue&type=template&id=ff243acc&scoped=true"
import script from "./SourceTag.vue?vue&type=script&lang=js"
export * from "./SourceTag.vue?vue&type=script&lang=js"

import "./SourceTag.vue?vue&type=style&index=0&id=ff243acc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff243acc"]])

export default __exports__